<template>
  <v-alert
    :color="plan === 'default' ? 'grey' : 'success'"
    border="left"
    colored-border
    :icon="false"
    class="pl-6 pt-2 pb-2">
    <slot name="content">
      <div v-if="subscription.hydrated">
        <component :is="moduleComponent" :subscription="subscription" :readonly="readonly"></component>
      </div>
    </slot>
    <div>
      <slot name="actions" v-bind:subscription="subscription"></slot>
    </div>
  </v-alert>
</template>

<script>
import SubscriptionPlanContent from './SubscriptionPlanContent'
import SubscriptionPlanContentCheckPosition from './SubscriptionPlanContentCheckPosition'
import { camelCase } from 'lodash'

export default {
  name: 'SubscriptionPlan',
  components: { SubscriptionPlanContentCheckPosition, SubscriptionPlanContent },
  props: ['plan', 'module', 'readonly'],
  data () {
    return {
      subscription: this.$models.Subscription.get()
    }
  },
  computed: {
    moduleComponent () {
      const name = camelCase(this.module).charAt(0).toUpperCase() + camelCase(this.module).slice(1)
      const componentName = 'SubscriptionPlanContent' + name

      if (componentName in this.$options.components) {
        return componentName
      } else {
        return 'SubscriptionPlanContent'
      }
    }
  },
  mounted () {
    // Create a new subscription model based on current active subscription or default values in config
    let activeSubscription = null
    if (this.plan !== 'default' && this.$account.getSubscription(this.module).name === this.plan) {
      activeSubscription = this.$account.getSubscription(this.module)
    }

    // console.log(activeSubscription.options.max_monitor_plus_100_2026)
    this.subscription.hydrate(this.module, this.plan, activeSubscription)
  }
}
</script>

<style scoped>

</style>